import { OrderTypes } from "@/lib/supabase/enums";
import { useTranslation } from "react-i18next";

export const useGetTranslatedOrderType = () => {
  const { t } = useTranslation("translation");

  const getTranslatedOrderType = (orderType: OrderTypes) => {
    switch (orderType) {
      case OrderTypes.delivery:
        return t("OrderTypes.delivery");
      case OrderTypes.pickup:
        return t("OrderTypes.pickup");

      default:
        return orderType;
    }
  };

  return { getTranslatedOrderType };
};
